import React from 'react';
import type { IconSidebarMenu } from 'commons/modules/SidebarMenu/icon-sidebar-menu';
import { MENU_KEYS } from 'constants/constants';

const AdministrationIcon = ({
  currentImage,
  isExpanded,
  disabled,
  returnPath,
  open,
}: IconSidebarMenu) => {
  const logicOp = () => {
    const currentImg = currentImage === MENU_KEYS.administrationManagement;
    const expanded =
      isExpanded === `panel${MENU_KEYS.administrationManagement}`;
    const path =
      returnPath('/portafolio-modelo/clients') ||
      returnPath('/portafolio-modelo/perfiles') ||
      returnPath('/cumplimiento/operaciones') ||
      returnPath('/cumplimiento/restringidos') ||
      returnPath('/cumplimiento/servicios') ||
      returnPath('/cumplimiento/auditorias') ||
      returnPath('/cumplimiento/practicas-venta') ||
      returnPath('/cumplimiento/operaciones-inusuales') ||
      returnPath('/cumplimiento/alertas') ||
      returnPath('/cumplimiento/reportes-operatividad') ||
      returnPath('/cumplimiento/ebr') ||
      returnPath('/cumplimiento/riesgo') ||
      returnPath('/configuracion') ||
      returnPath('/archivos/operacion');

    return Boolean(currentImg || (path && !open) || (expanded && open));
  };

  if (disabled && currentImage !== MENU_KEYS.administrationManagement)
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#525067" />
        <path
          d="M15.783 14.826L24 13L32.217 14.826C32.4391 14.8754 32.6377 14.999 32.78 15.1764C32.9224 15.3538 33 15.5745 33 15.802V25.789C32.9999 26.7767 32.756 27.7492 32.2899 28.62C31.8238 29.4908 31.1499 30.2331 30.328 30.781L24 35L17.672 30.781C16.8503 30.2332 16.1765 29.4911 15.7103 28.6205C15.2442 27.7498 15.0002 26.7776 15 25.79V15.802C15 15.5745 15.0776 15.3538 15.22 15.1764C15.3623 14.999 15.5609 14.8754 15.783 14.826ZM17 16.604V25.789C17 26.4475 17.1626 27.0957 17.4733 27.6763C17.7839 28.2568 18.2332 28.7517 18.781 29.117L24 32.597L29.219 29.117C29.7667 28.7518 30.2158 28.2571 30.5265 27.6767C30.8372 27.0964 30.9998 26.4483 31 25.79V16.604L24 15.05L17 16.604ZM24 23C23.337 23 22.7011 22.7366 22.2322 22.2678C21.7634 21.7989 21.5 21.163 21.5 20.5C21.5 19.837 21.7634 19.2011 22.2322 18.7322C22.7011 18.2634 23.337 18 24 18C24.663 18 25.2989 18.2634 25.7678 18.7322C26.2366 19.2011 26.5 19.837 26.5 20.5C26.5 21.163 26.2366 21.7989 25.7678 22.2678C25.2989 22.7366 24.663 23 24 23ZM19.527 28C19.6482 26.8984 20.1717 25.8803 20.9971 25.1407C21.8225 24.4012 22.8918 23.9922 24 23.9922C25.1082 23.9922 26.1775 24.4012 27.0029 25.1407C27.8283 25.8803 28.3518 26.8984 28.473 28H19.527Z"
          fill="#757A96"
        />
      </svg>
    );

  if (logicOp())
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" fill="#F4F2F9" />
        <path
          d="M15.783 14.826L24 13L32.217 14.826C32.4391 14.8754 32.6377 14.999 32.78 15.1764C32.9224 15.3538 33 15.5745 33 15.802V25.789C32.9999 26.7767 32.756 27.7492 32.2899 28.62C31.8238 29.4908 31.1499 30.2331 30.328 30.781L24 35L17.672 30.781C16.8503 30.2332 16.1765 29.4911 15.7103 28.6205C15.2442 27.7498 15.0002 26.7776 15 25.79V15.802C15 15.5745 15.0776 15.3538 15.22 15.1764C15.3623 14.999 15.5609 14.8754 15.783 14.826ZM17 16.604V25.789C17 26.4475 17.1626 27.0957 17.4733 27.6763C17.7839 28.2568 18.2332 28.7517 18.781 29.117L24 32.597L29.219 29.117C29.7667 28.7518 30.2158 28.2571 30.5265 27.6767C30.8372 27.0964 30.9998 26.4483 31 25.79V16.604L24 15.05L17 16.604ZM24 23C23.337 23 22.7011 22.7366 22.2322 22.2678C21.7634 21.7989 21.5 21.163 21.5 20.5C21.5 19.837 21.7634 19.2011 22.2322 18.7322C22.7011 18.2634 23.337 18 24 18C24.663 18 25.2989 18.2634 25.7678 18.7322C26.2366 19.2011 26.5 19.837 26.5 20.5C26.5 21.163 26.2366 21.7989 25.7678 22.2678C25.2989 22.7366 24.663 23 24 23ZM19.527 28C19.6482 26.8984 20.1717 25.8803 20.9971 25.1407C21.8225 24.4012 22.8918 23.9922 24 23.9922C25.1082 23.9922 26.1775 24.4012 27.0029 25.1407C27.8283 25.8803 28.3518 26.8984 28.473 28H19.527Z"
          fill="#6D46DD"
        />
      </svg>
    );

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" fill="#525067" />
      <path
        d="M15.783 14.826L24 13L32.217 14.826C32.4391 14.8754 32.6377 14.999 32.78 15.1764C32.9224 15.3538 33 15.5745 33 15.802V25.789C32.9999 26.7767 32.756 27.7492 32.2899 28.62C31.8238 29.4908 31.1499 30.2331 30.328 30.781L24 35L17.672 30.781C16.8503 30.2332 16.1765 29.4911 15.7103 28.6205C15.2442 27.7498 15.0002 26.7776 15 25.79V15.802C15 15.5745 15.0776 15.3538 15.22 15.1764C15.3623 14.999 15.5609 14.8754 15.783 14.826ZM17 16.604V25.789C17 26.4475 17.1626 27.0957 17.4733 27.6763C17.7839 28.2568 18.2332 28.7517 18.781 29.117L24 32.597L29.219 29.117C29.7667 28.7518 30.2158 28.2571 30.5265 27.6767C30.8372 27.0964 30.9998 26.4483 31 25.79V16.604L24 15.05L17 16.604ZM24 23C23.337 23 22.7011 22.7366 22.2322 22.2678C21.7634 21.7989 21.5 21.163 21.5 20.5C21.5 19.837 21.7634 19.2011 22.2322 18.7322C22.7011 18.2634 23.337 18 24 18C24.663 18 25.2989 18.2634 25.7678 18.7322C26.2366 19.2011 26.5 19.837 26.5 20.5C26.5 21.163 26.2366 21.7989 25.7678 22.2678C25.2989 22.7366 24.663 23 24 23ZM19.527 28C19.6482 26.8984 20.1717 25.8803 20.9971 25.1407C21.8225 24.4012 22.8918 23.9922 24 23.9922C25.1082 23.9922 26.1775 24.4012 27.0029 25.1407C27.8283 25.8803 28.3518 26.8984 28.473 28H19.527Z"
        fill="#F4F2F9"
      />
    </svg>
  );
};

export default AdministrationIcon;
